import { render, staticRenderFns } from "./IconQuestionFilled.vue?vue&type=template&id=4b6cf524"
import script from "./IconQuestionFilled.vue?vue&type=script&lang=js"
export * from "./IconQuestionFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports